<template>
	<div class="reset-password card">
		<div class="header4">Reset Password</div>
		<div class="paragraph"></div>
		<form class="reset-form" action="#">
			<InputBox placeHolder="Current Password" inputStyleType="sharp" v-model="formData.currentPassword" type="password" required />
			<InputBox placeHolder="New Password" inputStyleType="sharp" v-model="formData.newPassword" type="password" required />
			<InputBox placeHolder="Confirm Password" inputStyleType="sharp" v-model="formData.confirmPassword" type="password" required />

			<div class="button-cont">
				<Button title="Clear" buttonType="outline" :onClick="resetForm" />
				<Button title="Submit" :onClick="submit" />
			</div>
		</form>
	</div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
// import { Prop } from "vue-property-decorator";
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { PASS_RESET } from "./../../store/constants";

export default {
	name: "reset-password",
	components: {
		InputBox,
		Button,
	},
	data() {
		return {
			formData: {
				currentPassword: "",
				newPassword: "",
				confirmPassword: "",
			},
		};
	},
	methods: {
		async submit() {
			try {
				await this.$store.dispatch(PASS_RESET, this.formData);
				this.$toast.open({
					message: "Password Changed!",
					position: "top",
					type: "success",
				});
				this.resetForm();
			} catch (ex) {
				this.$toast.open({
					message: `Unable to change password: ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
		},
		resetForm() {
			this.formData = {
				currentPassword: "",
				newPassword: "",
				confirmPassword: "",
			};
		},
		register() {
			this.$router.push({ name: "Register" });
		},
	},
};
</script>

<style scoped lang="scss">
.reset-password {
	padding: 25px 20px;
	text-align: left;
	.header4 {
		color: var(--dark-gray);
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
		opacity: 0.5;
	}
	.reset-form {
		margin-top: 30px;
	}
	.button-cont {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		margin-top: 25px;
		margin-bottom: 20px;
		max-width: 300px;
		.outline.button {
			width: 110px;
		}
		.button {
			width: 170px;
		}
	}
	.sharp.input-box .input-cont input {
		width: 290px;
	}
}
</style>
